import { Dialog, DialogContent, ThemeProvider } from "@mui/material";
import { PaperArrastavel } from "app/components/dialog-arrastavel/PaperArrastavel";
import React, { useCallback } from "react";
import { theme } from "../materialUiTheme";
import { removerComponenteReact } from "../renderizarOuRemoverComponentReact";
import { IniciarOrcamentoContainer } from "./IniciarOrcamentoContainer";

// Definir a interface para as props
interface IniciarOrcamentoContainerDialogProps {
    tipoOrcamento: string; // Adicione outras props, se necessário
}

// Criar o ThemeProvider fora do componente para evitar recriação
const CustomThemeProvider = ({ children }) => (
    <ThemeProvider theme={theme}>
        {children}
    </ThemeProvider>
);

// Aplicar a interface ao componente
export const IniciarOrcamentoContainerDialog: React.FC<IniciarOrcamentoContainerDialogProps> = React.memo(({ tipoOrcamento }) => {
    const handleCancelar = useCallback(() => {
        // Passar um objeto em vez de uma string
        removerComponenteReact("iniciar-orcamento-container-dialog" );
    }, []);

    return (
        <CustomThemeProvider>
            <Dialog open={true} fullScreen PaperComponent={PaperArrastavel}>
                <DialogContent>
                    <div className="_flex _justify-center _w-full _mt-24">
                        <IniciarOrcamentoContainer
                            tipoOrcamento={tipoOrcamento}
                            onCancelar={handleCancelar}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </CustomThemeProvider>
    );
});